import { c as _c } from "react/compiler-runtime";
import { METRIC_OPTIONS } from '@/modules/finances/types';
import { DrawerSelect } from '@/modules/shared/components/filter-drawer/filter-drawer';
import type { Option } from '@/modules/shared/components/form/multiselect';
interface MetricSelectProps {
  metric: METRIC_OPTIONS | null;
  setMetric: (metric: METRIC_OPTIONS) => Promise<URLSearchParams>;
  className?: string;
}
const metricOptions: Option[] = [{
  value: METRIC_OPTIONS.Actuals,
  label: METRIC_OPTIONS.Actuals,
  group: 'Metrics'
}, {
  value: METRIC_OPTIONS.Budget,
  label: METRIC_OPTIONS.Budget,
  group: 'Metrics'
}, {
  value: METRIC_OPTIONS.Forecast,
  label: METRIC_OPTIONS.Forecast,
  group: 'Metrics'
}, {
  value: METRIC_OPTIONS.NetExpensesOnChain,
  label: METRIC_OPTIONS.NetExpensesOnChain,
  group: 'Metrics'
}, {
  value: METRIC_OPTIONS.NetProtocolOutflow,
  label: METRIC_OPTIONS.NetProtocolOutflow,
  group: 'Metrics'
}];
function BreakdownMetricSelectDrawer(t0) {
  const $ = _c(5);
  const {
    metric,
    setMetric
  } = t0;
  let t1;
  if ($[0] !== setMetric) {
    t1 = value => {
      setMetric(value as METRIC_OPTIONS);
    };
    $[0] = setMetric;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  const t2 = metric ?? undefined;
  let t3;
  if ($[2] !== handleChange || $[3] !== t2) {
    t3 = <DrawerSelect value={t2} onChange={handleChange} label="Metrics" options={metricOptions} />;
    $[2] = handleChange;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export { BreakdownMetricSelectDrawer };